import { axiosAnonymous, axiosNode } from '../config/axiosConfig';
import { alertErrorImg } from '../plugins/sweetalert2';

const convertirArchivoUrl = archivo => {
  return new Promise((resolve, reject) => {
    const lectorArchivo = new FileReader();
    lectorArchivo.onload = () => resolve(lectorArchivo.result);
    lectorArchivo.onerror = () => reject(lectorArchivo.error);
    lectorArchivo.readAsDataURL(archivo);
  });
};

const obtenerLogoAbierto = async nombreArchivo => {
  const respuesta = await axiosAnonymous.get('open/api-documentos/logo', {
    params: { nombreArchivo },
    responseType: 'blob',
  });

  return convertirArchivoUrl(respuesta.data);
};

const obtenerArchivo = async (directorioRaiz, nombreArchivo) => {
  const respuesta = await axiosNode.get('api-documentos/archivos', {
    params: { directorioRaiz, nombreArchivo },
    responseType: 'blob',
  });

  return convertirArchivoUrl(respuesta.data);
};

const guardarArchivo = async (directorioRaiz, datosFormulario) => {
  try {
    const respuesta = await axiosNode.post(
      'api-documentos/archivos',
      datosFormulario,
      {
        params: { directorioRaiz },
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return respuesta.data;
  } catch (error) {
    alertErrorImg();
    throw error;
  }
};

const actualizarArchivo = async (
  directorioRaiz,
  nombreArchivo,
  datosFormulario
) => {
  try {
    const respuesta = await axiosNode.put(
      'api-documentos/archivos',
      datosFormulario,
      {
        params: { directorioRaiz, nombreArchivo },
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return respuesta.data;
  } catch (error) {
    alertErrorImg();
    throw error;
  }
};

export default {
  obtenerLogoAbierto,
  obtenerArchivo,
  guardarArchivo,
  actualizarArchivo,
};
